import React, { Component } from 'react';
import { Col, DatePicker, Form, Modal, Row } from 'antd';

import { queryBusinessInfo } from '@api/crm/crm';
import SelectUser from '@comm/SelectUser';
import moment from 'moment';

const FormItem = Form.Item;

class ModalAllot extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    if (this.props.uuid) {
      this.getBusiness();
    }
  }

  getBusiness = () => {
    queryBusinessInfo({
      uuid: this.props.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({});
      }
    });
  };

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { handleSubmit, record } = this.props;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        handleSubmit({
          ...values,
          protectionMaturityDate: values.protectionMaturityDate.format('YYYY-MM-DD'),
          customUuid: record.uuid,
        });
      }
    });
  };

  handleSelectChangge = () => {
    return (value, selectedOptions) => {
      this.props.form.setFieldsValue({
        protectionUserName: selectedOptions.props.children,
      });
    };
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { handleModalVisible, record } = this.props;
    getFieldDecorator('protectionUserName');
    return (
      <Modal title="分配" visible onCancel={() => handleModalVisible(false)} onOk={this.submit}>
        <Form onSubmit={this.submit}>
          <Row>
            <Col span={24}>
              <FormItem label="保护时间">
                {getFieldDecorator('protectionMaturityDate', {
                  rules: [{ required: true, message: '请选择保护时间!' }],
                  initialValue: record.maturityDate
                    ? moment.unix(record.maturityDate / 1000)
                    : record.maturityDate,
                })(<DatePicker style={{ width: '100%' }} />)}
              </FormItem>
            </Col>
            <Col span={24}>
              <SelectUser
                {...this.props}
                field={{
                  field: 'protectionUser',
                  fieldName: '保护人',
                  isRequire: true,
                }}
                data={record}
                onChange={this.handleSelectChangge()}
              />
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(ModalAllot);



// WEBPACK FOOTER //
// ./src/components/crm/custom/protectWatch/ModalAllot.js